import { MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import useDeviceType from '@travel/ui/utils/useDeviceType';
import { cx } from '@travel/utils';
import { NOT_FOUND } from 'favoriteList/constants/favoriteLists';
import styles from './emptyMessage.module.scss';
type Props = {
  isPlanList: boolean;
  status: string;
  statusMsg: string;
};

const EmptyMessage = (props: Props) => {
  const { isPlanList, status, statusMsg } = props;
  const deviceType = useDeviceType();
  const isNotFound = status === NOT_FOUND;
  const isSP = deviceType === MOBILE_SCREEN;
  const emptyMessage = `まだ${isPlanList ? 'プラン' : '宿泊施設'}が登録されていません`;

  return (
    <div
      data-testid="empty-message-id"
      className={cx(
        isSP ? styles.emptyMessageContainerSP : styles.emptyMessageContainerPC,
        !isSP && isNotFound && styles.notFoundContainer,
      )}
    >
      <p
        className={cx(
          isSP ? styles.emptyMessageSP : styles.emptyMessagePC,
          !isSP && isNotFound && styles.notFoundMessage,
        )}
      >
        {isNotFound ? <div dangerouslySetInnerHTML={{ __html: statusMsg }} /> : emptyMessage}
      </p>
    </div>
  );
};

export default EmptyMessage;
